import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class PurchaseOrders_ds_inbound_orders_grid_propertiesService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { orderIds?: number[] }): 
  Promise<{ result: { Id?: number, PreferredWarehouseId?: number, ValidationResults?: { CreatedSysDateTime?: string, Notes?: string, ValidationExecutionResult?: { DisplayName?: string } }[], DockAppointmentsOrdersLookup?: { DockAppointmentId?: number, DockAppointment?: { LookupCode?: string, ScheduledArrival?: string, StatusId?: number, WarehouseId?: number, AssignedLocation?: { Name?: string, ShortName?: string }, ScheduledLocation?: { Name?: string, ShortName?: string } } }[] }[] }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { orderIds?: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, PreferredWarehouseId?: number, ValidationResults?: { CreatedSysDateTime?: string, Notes?: string, ValidationExecutionResult?: { DisplayName?: string } }[], DockAppointmentsOrdersLookup?: { DockAppointmentId?: number, DockAppointment?: { LookupCode?: string, ScheduledArrival?: string, StatusId?: number, WarehouseId?: number, AssignedLocation?: { Name?: string, ShortName?: string }, ScheduledLocation?: { Name?: string, ShortName?: string } } }[] }[], totalCount: number }> 
  {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { orderIds?: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, PreferredWarehouseId?: number, ValidationResults?: { CreatedSysDateTime?: string, Notes?: string, ValidationExecutionResult?: { DisplayName?: string } }[], DockAppointmentsOrdersLookup?: { DockAppointmentId?: number, DockAppointment?: { LookupCode?: string, ScheduledArrival?: string, StatusId?: number, WarehouseId?: number, AssignedLocation?: { Name?: string, ShortName?: string }, ScheduledLocation?: { Name?: string, ShortName?: string } } }[] }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      orderIds?: number[]    }) {
      return false;
    }
}
